import db from '../../versa/db.js';
import api from '../api.js';

// Requires observer.js
// Prioridade: 1) customer_prices (tabela por cliente), 2) price_list do cliente
export default function (...args)
{
	return {
		async actions(ev, publisher, value)
		{
			let company_id = this.locate('company_id')?.getValue?.();
			let customer_id = this.locate('customer_id')?.getValue?.();
			let product_id = this.locate(this.makeId('product_id-0'))?.getValue?.();
			// Só usa value como product_id quando a mudança veio do campo produto (evita usar customer_id em linhas vazias)
			const isProductChange = publisher && String(publisher.selector || '').includes('product_id');
			if (!product_id && isProductChange && value != null && !isNaN(Number(value)) && Number(value) >= 0)
				product_id = value;
			product_id = Number(product_id);
			if (!company_id || !customer_id || !product_id || product_id <= 0)
				return;
			// Resolve customer_id (pode ser id numérico ou label)
			let cid = Number(customer_id);
			if (isNaN(cid) || cid < 0)
			{
				let custField = this.locate('customer_id');
				let node = custField ? document.querySelector(custField.selector) : null;
				let opt = node?.list ? Array.from(node.list.options || []).find(o =>
					o.innerText?.trim() === String(customer_id).trim() || o.value == customer_id
				) : null;
				cid = opt ? Number(opt.value) : -1;
			}
			if (isNaN(cid) || cid < 0)
				return;
			customer_id = cid;

			// 1) Tabela de preço por cliente (customer_prices)
			let unit_price = null;
			let discount = null;
			try
			{
				let resp = await api.call(api.customer_price_get, company_id, customer_id, product_id);
				if (resp && typeof resp.unit_price === 'number')
				{
					unit_price = resp.unit_price;
					if (resp.discount != null && !isNaN(Number(resp.discount)))
						discount = Number(resp.discount);
				}
			}
			catch (_) { }

			// 2) Fallback: lista de preço do cliente (price_list_id)
			if (unit_price == null)
			{
				let customer = await db.get('customers', [company_id, customer_id]);
				if (!customer || !customer['price_list_id'])
					return;
				let price_list = await db.get('price_lists', [company_id, customer['price_list_id']]);
				if (!price_list || !price_list.prices)
					return;
				let price = price_list.prices.find(p => p.product_id == product_id);
				if (!price)
					return;
				unit_price = price.unit_price;
				if (price.discount != null)
					discount = Number(price.discount);
			}

			if (unit_price != null)
			{
				this.setValue(unit_price);
				this.refresh();
				let discountField = this.locate(this.makeId('discount-0'));
				if (discount != null && discountField)
				{
					discountField.setValue(discount);
					discountField.refresh();
				}
			}
		}
	};
}

